import { makeStyles } from "@material-ui/core";
import { blue, grey } from "@material-ui/core/colors";

export type UseStylesProps = { separator: boolean };

export const SEPARATOR_HEIGHT = 40;
export default makeStyles(({ spacing, palette }) => ({
  separator: ({ separator }: UseStylesProps) => ({
    display: "flex",
    height: separator ? SEPARATOR_HEIGHT : 0,
    overflow: "hidden",
    width: separator ? "100%" : 200,
    position: "relative",
    alignItems: "center",
    margin: separator ? "auto" : "0 auto",
    transition: "all 0.3s ease",
    "&::before": {
      content: "''",
      position: "absolute",
      display: "block",
      top: "50%",
      left: 0,
      transform: "translateY(-50%)",
      width: "100%",
      height: 1,
      background: blue.A100,
    },
  }),
  button: ({ separator }: UseStylesProps) => ({
    margin: "0 auto",
    display: "flex",
    flexWrap: "nowrap",
    maxWidth: separator ? "50%" : "none",
    // Masks the separator line, so it takes the host panel's colour.
    background: `var(--draggable-surface-background, ${palette.common.white})`,
    padding: spacing(0.5),
    textAlign: "center",
    fontSize: "12px",
    lineHeight: "14px",
    color: separator ? blue.A100 : grey[500],
  }),
  input: {
    height: 24,
    fontSize: 12,
    padding: "2px !importand",
    background: palette.common.white,
  },
  inputContainer: ({ separator }: UseStylesProps) => ({
    background: `var(--draggable-surface-background, ${palette.common.white})`,
    margin: "0 auto",
    padding: spacing(0, 0.75),
    maxWidth: separator ? "50%" : "84px",
    zIndex: 1,
  }),
  removeButton: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    background: `var(--draggable-surface-background, ${palette.common.white})`,
    padding: spacing(0.5),
    fontSize: "10px",
    color: grey[500],
  },
  removeIcon: {
    fontSize: 12,
    marginRight: spacing(0.5),
  },
}));
